import React from 'react';
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

const SubTitleBox = styled(Typography)(({ theme }) => ({
    color: '#9AA6B2',
    fontSize: '1rem',
    maxWidth: '600px',
    margin: '10px auto',
    marginBottom: '50px',
    [theme.breakpoints.down('sm')]: {
        fontSize: '0.8rem',
        marginBottom: '30px',
        padding: '0 16px',
    },
}))

const SubTitle = ({ children, variant }) => {
    return (
        <SubTitleBox variant={variant}>
            {children}
        </SubTitleBox>
    );
};

export default SubTitle;